import React, { useState } from 'react';
import { Logo } from '../components/Logo';
import { Button } from '../components/Button';
import { Input } from '../components/Input';
import { Card } from '../components/Card';
interface LoginScreenProps {
  onLogin: () => void;
}
export function LoginScreen({
  onLogin
}: LoginScreenProps) {
  const [step, setStep] = useState<'email' | 'code'>('email');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const handleSendCode = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) setStep('code');
  };
  const handleVerify = (e: React.FormEvent) => {
    e.preventDefault();
    if (code.length === 6) onLogin();
  };
  return <div className="min-h-screen flex items-center justify-center p-4" data-id="element-68">
      <Card className="w-full max-w-md p-8" data-id="element-69">
        <div className="flex flex-col items-center mb-8" data-id="element-70">
          <Logo size="lg" className="mb-2" data-id="element-71" />
        </div>

        {step === 'email' ? <form onSubmit={handleSendCode} className="space-y-6" data-id="element-72">
            <div data-id="element-73">
              <Input type="email" placeholder="Enter your email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus data-id="element-74" />
            </div>

            <Button type="submit" fullWidth size="lg" data-id="element-75">
              Send Code
            </Button>

            <p className="text-sm text-gray-400 text-center" data-id="element-76">
              We'll send a 6-digit verification code to your email.
            </p>
          </form> : <form onSubmit={handleVerify} className="space-y-6" data-id="element-77">
            <div data-id="element-78">
              <Input type="text" placeholder="000000" value={code} onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))} required autoFocus className="text-center text-2xl tracking-widest font-mono" data-id="element-79" />
            </div>

            <Button type="submit" fullWidth size="lg" disabled={code.length !== 6} data-id="element-80">
              Verify
            </Button>

            <div className="text-center space-y-2" data-id="element-81">
              <p className="text-sm text-gray-400" data-id="element-82">
                Enter the code sent to{' '}
                <span className="text-white font-medium" data-id="element-83">{email}</span>
              </p>
              <button type="button" className="text-sm text-amber hover:text-amber-hover transition-colors" onClick={() => setStep('email')} data-id="element-84">
                Resend code
              </button>
            </div>
          </form>}
      </Card>
    </div>;
}